import { useState, useEffect, useCallback } from 'react';
import EmailTemplateApiService from 'app/apiService/emailTemplate/emailTemplateApiService';

export function useTemplateTypes() {
  const [types, setTypes] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTemplateTypes = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await EmailTemplateApiService.getTemplateTypes();
      const typeList = response?.body?.types ?? (response as any)?.types;
      if (Array.isArray(typeList)) {
        setTypes(typeList);
      } else {
        setTypes([]);
      }
    } catch (err: any) {
      setError(err?.message || 'Failed to fetch template types');
      setTypes([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchTemplateTypes();
  }, [fetchTemplateTypes]);

  return { types, loading, error, refetch: fetchTemplateTypes };
}
